import { useQContent } from '@exam-management/common/qcontent-provider';
import {
  Dialog,
  DialogTitle,
  Divider,
  type DialogProps,
  DialogActions,
  Button,
} from '@shared/components';
import { formatDate } from '@shared/utils';

import { DEFAULT_CRITERIA, type DifficultyLevel } from '../../components';
import { getDifficultyCriteria, getPStatId } from '../../utils';
import { PUseHistoryList, type PUseListItem } from '../p-use-history-list';

interface PUseHistoryModalProps extends DialogProps {
  onClose: () => void;
  open: boolean;
}

export default function PUseHistoryModal(props: Readonly<PUseHistoryModalProps>) {
  const { onClose, open: isOpen } = props;

  const { qContent } = useQContent();
  const rows: PUseListItem[] =
    qContent.metadata.pStats?.map((pStat) => {
      return {
        id: getPStatId(pStat),
        pStatPreview: pStat.pValue.toFixed(2),
        pStat: pStat.pValue,
        selected: pStat.selected ?? null,
        difficulty: getDifficultyCriteria(DEFAULT_CRITERIA, pStat.pValue)
          ?.difficultyLevel as DifficultyLevel,
        numberOfExaminee: pStat.sampleSize,
        calculatedDate: formatDate(pStat.calculatedAt),
        startedDate: formatDate(pStat.firstUsedAt),
        updatedBy: pStat.updatedUserFullName,
      };
    }) ?? [];

  const handleClose = () => {
    onClose();
  };

  return isOpen ? (
    <Dialog open={isOpen} maxWidth='lg' onClose={handleClose}>
      <DialogTitle onClose={onClose}>ค่า P จากข้อมูลสถิติ</DialogTitle>
      <Divider />
      <PUseHistoryList rows={rows} />
      <Divider />
      <DialogActions>
        <Button onClick={onClose} sx={{ width: '100px' }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  ) : null;
}
